/// FOURJS_START_COPYRIGHT(D,2016)
/// Property of Four Js*
/// (c) Copyright Four Js 2016, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

/**
 * @readonly
 * @enum {string};
 */
gbc.constants.widgetEvents = {
  activate: "g_activate",
  afterLayout: "g_afterLayout",
  blur: "g_blur",
  buildContextMenuCopyArrayActions: "g_buildContextMenuCopyArrayActions",
  change: "g_change",
  click: "g_click",
  clickSecondaryIcon: "g_clickSecondaryIcon",
  close: "g_close",
  copy: "g_copy",
  copyCell: "g_copyCell",
  copyCurrentRow: "g_copyCurrentRow",
  copyRow: "g_copyRow",
  completerDataChanged: "g_completerDataChanged",
  contextMenu: "g_contextMenu",
  created: "g_created",
  disable: "g_disable",
  displayChanged: "g_displayChanged",
  destroyed: "g_destroyed",
  doubleClick: "g_doubleClick",
  dropDownBeforeOpen: "g_dropDownBeforeOpen",
  dropDownOpen: "g_dropDownOpen",
  dropDownClose: "g_dropDownClose",
  enter: "g_enter",
  esc: "g_esc",
  floatingPanelDocked: "g_floatingPanelDocked",
  floatingPanelUndocked: "g_floatingPanelUndocked",
  floatingPanelShown: "g_floatingPanelShown",
  floatingPanelHidden: "g_floatingPanelHidden",
  focus: "g_focus",
  focusRestored: "g_focusRestored",
  gbcReady: "g_gbcReady",
  gbcQaReady: "g_gbcQaReady",
  gridInfoChanged: "g_gridInfoChanged",
  iconChanged: "g_iconChanged",
  keyDown: "g_keyDown",
  keyUp: "g_keyUp",
  keyArrowDown: "g_keyArrowDown",
  keyArrowLeft: "g_keyArrowLeft",
  keyArrowRight: "g_keyArrowRight",
  keyArrowUp: "g_keyArrowUp",
  keyEnd: "g_keyEnd",
  keyHome: "g_keyHome",
  keyPageUp: "g_keyPageUp",
  keyPageDown: "g_keyPageDown",
  keySpace: "g_keySpace",
  layout: "g_layout",
  layoutApplied: "g_layoutApplied",
  layoutInformationChanged: "g_layoutInformationChanged",
  layoutRequest: "g_layoutRequest",
  logStepDone: "g_logStepDone",
  logForwardDone: "g_logForwardDone",
  logPlayerError: "g_logPlayerError",
  loseFocus: "g_loseFocus",
  modalOut: "g_modalOut",
  modalResize: "g_modalResize",
  mouseWheel: "g_mouseWheel",
  offset: "g_offset",
  onBeforeUnload: "g_onbeforeunload",
  onBlur: "g_onBlur",
  onUnload: "g_onunload",
  openDropDown: "g_openDropDown",
  pageSize: "g_pageSize",
  processing: "g_processing",
  ready: "g_ready",
  requestFocus: "g_requestFocus",
  restart: "g_restart",
  rightClick: "g_rightClick",
  rowAction: "g_rowAction",
  rowBoundMenu: "g_rowBoundMenu",
  scroll: "g_scroll",
  select: "g_select",
  selectAll: "g_selectAll",
  sideBarDrawerShown: "g_sideBarDrawerShown",
  sideBarDrawerHidden: "g_sideBarDrawerHidden",
  sideBarRailShown: "g_sideBarRailShown",
  sideBarRailHidden: "g_sideBarRailHidden",
  sideBarRailUpdated: "g_sideBarRailUpdated",
  sideBarDrawerDocked: "g_sideBarDrawerDocked",
  sideBarDrawerUndocked: "g_sideBarDrawerUndocked",
  sideBarDrawerUpdated: "g_sideBarDrawerUpdated",
  space: "g_space",
  splitter: "g_splitter",
  splitterStart: "g_splitterStart",
  splitterEnd: "g_splitterEnd",
  splitViewChange: "g_splitViewChange",
  swipeStart: "g_swipeStart",
  swipeEnd: "g_swipeEnd",
  tabNavigate: "g_tabNavigate",
  tabActivate: "g_tabActivate",
  tableClickOnContainer: "g_tableClickOnContainer",
  tableColumnsChanged: "g_tableColumnsChanged",
  tableDragEnter: "g_tableDragEnter",
  tableDragEnd: "g_tableDragEnd",
  tableDragLeave: "g_tableDragLeave",
  tableDragStart: "g_tableDragStart",
  tableDrop: "g_tableDrop",
  tableDragOver: "g_tableDragOver",
  tableHeaderSort: "g_tableHeaderSort",
  tableHeaderOrder: "g_tableHeaderOrder",
  tableLeftFrozen: "g_tableTableLeftFrozen",
  tableOrderColumn: "g_tableOrderColumn",
  tableResetToDefault: "g_tableResetToDefault",
  tableResizeCol: "g_tableResizeCol",
  tableSetSortSpec: "g_tableSetSortSpec",
  tableRightFrozen: "g_tableTableRightFrozen",
  tableShowHideCol: "g_tableShowHideCol",
  tableClick: "g_tableClick",
  themeChange: "g_themeChange",
  titleChanged: "g_titleChanged",
  toggleClick: "g_toggleClick",
  touchEnd: "g_touchEnd",
  touchMove: "g_touchMove",
  touchStart: "g_touchStart",
  valueChanged: "g_valueChanged",
  visibilityChange: "g_visibilityChange",
  webcomponentKeyDown: "g_webcomponentKeyDown",
  webcomponentClick: "g_webcomponentClick",
  webcomponentContextMenu: "g_webcomponentContextMenu",
  requestDisplay: "g_requestDisplay",
  listReorder: "g_listReorder",
  listShowAll: "g_listShowAll",
  listItemVisibility: "g_listItemVisibility",
  listItemToggleVisibility: "g_listItemToggleVisibility"
};
